import { useQuery } from 'urql';
import { propertyPageQuery } from './propertyPageQuery';
import { useUrlContext } from '../../contexts/UrlContext/UrlContext';
import { getSlugFromPathname } from '../../helpers/getSlugFromPathname';
import { usePropertyId } from '../../contexts/PropertyIdContext/PropertyIdContext';
import { useShowAVMLoggedOut } from '../hooks/useShowAVMLoggedOut';
import { useFeatureRollout } from '@rea-argonaut/experiment';
import { useAccountQuery } from '../../hooks/useAccountQuery';

export const usePropertyPageQuery = () => {
  const { pathname } = useUrlContext();
  const slug = getSlugFromPathname(pathname);
  const propertyId = usePropertyId();
  const toggleShowAVMData = useShowAVMLoggedOut();
  const toggleShowOriginNbnBrick = useFeatureRollout('origin_nbn_brick').isEnabled();
  const toggleMainImageDataMigration = useFeatureRollout(
    'similar_and_neighbouring_properties_image_data_migration',
  ).isEnabled();
  const value = useAccountQuery();
  const togglePropertyReport = useFeatureRollout('property_report', {
    customUserAttributes: { lockeId: value?.data?.account?.lockeId ?? '' },
  }).isEnabled();
  const toggleBYBLegalDisclaimers = useFeatureRollout('byb_legal_disclaimers').isEnabled();
  const togglePcaChat = useFeatureRollout('property_chat').isEnabled();
  const toggleGovernmentOverlaysUpdate = useFeatureRollout(
    'government_overlays_update',
  ).isEnabled();
  const toggleAllianzRenewalBannerV2 = useFeatureRollout('allianz_renewal_banner_v2').isEnabled();

  const [result] = useQuery({
    query: propertyPageQuery,
    variables: {
      slug,
      id: propertyId,
      toggleShowAVMData,
      toggleShowOriginNbnBrick,
      toggleMainImageDataMigration,
      togglePropertyReport,
      togglePcaChat,
      toggleBYBLegalDisclaimers,
      toggleGovernmentOverlaysUpdate,
      toggleAllianzRenewalBannerV2,
    },
  });

  const propertyPageContent = result.data?.propertyPageBySlugV3;

  if (
    !propertyPageContent ||
    propertyPageContent?.__typename === 'ErrorPage' ||
    propertyPageContent?.__typename === 'Redirect'
  )
    return null;

  return {
    ...result,
    data: {
      ...result.data,
      propertyPageBySlugV3: propertyPageContent,
    },
  };
};
